'use client'
import * as React from 'react'
import { BlogDetailHeroProps } from './types'
import LeftIcon from '../../../icons/LeftIcon'
import Link from 'next/link'

const BlogDetailHero = ({ content, tags, image }: BlogDetailHeroProps) => {
    return (
        <div className="max-w-[100vw] relative after:top-[-166px] after:pointer-events-none after:z-5 after:content-[''] after:block after:absolute after:inset-0 after:bg-green-light before:right-[-50vw] before:translate-y-full before:rotate-[-3deg] lg:before:rotate-[-6deg] before:z-10 before:block before:w-[300vw] before:h-[100%] before:bottom-[0] before:right-0 relative before:absolute before:content-[''] before:bg-white before:origin-top lg:pb-28">
            <div className="flex-col lg:flex-row flex gap-10 mt-[76px] z-10 container">
                <div className="mt-[10%] flex-shrink-0 w-full lg:w-6/12 z-10">
                    <Link
                        href={'/blog'}
                        className="translate-all transform-gpu ease duration-500 group flex gap-4 items-center text-[16px] leaing-[21px] font-bold"
                    >
                        <LeftIcon className="translate-all transform-gpu ease duration-500 group-hover:translate-x-[4px] fill-black group-hover:fill-green-brand" />{' '}
                        Terug naar het overzicht
                    </Link>
                    <div className="mt-[50px] lg:mt-[60px]">{content}</div>
                    <div className="flex-wrap mt-7 flex gap-[10px]">
                        {tags?.map(tag => (
                            <div className="hover:bg-grey/80 text-grey/80 hover:text-white cursor-pointer flex items-center justify-center h-[24px] w-fit rounded-full px-[12px] border-grey/80 border-[1px]">
                                <span className="block whitespace-nowrap font-bold text-[10px] leading-[10px]">
                                    {tag}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="[&>img]:h-full [&>img]:w-full max-w-full w-[400px] lg:w-[760px] h-[360px] lg:h-[820px] lg:-mb-[410px] flex-shrink-0 origin-top-right right-[-16px] rotate-[-3deg] lg:rotate-[-6deg] w-full lg:w-[60%] z-10">
                    {image}
                </div>
            </div>
        </div>
    )
}

export default BlogDetailHero
